module.exports = __webpack_public_path__ + "img/hand.592c0647.png";